import { useReducer } from "react";
import axios from "axios";
import { getBasePath } from "../../Helpers/getEnvVar";
import { getAuthToken } from "../../Helpers/localStorage";

const uploadLandingBackgroundImageHookInitialState = {
  isFetching: false,
  isSuccessful: false,
  errorMessage: "",
  result: {},
};

const uploadLandingBackgroundImageHookReducer = (state, action) => {
  switch (action.type) {
    case "fetching":
      return {
        ...state,
        isFetching: true,
        isSuccessful: false,
        errorMessage: "",
        result: {},
      };
    case "success":
      return {
        ...state,
        isFetching: false,
        isSuccessful: true,
        result: { ...action.payload },
      };
    case "error":
      return {
        ...state,
        isFetching: false,
        isSuccessful: false,
        errorMessage: action.payload,
      };
    default:
      throw new Error("Unsupported Action");
  }
};

const useUploadLandingBackgroundImage = () => {
  const [backgroundImage, dispatch] = useReducer(uploadLandingBackgroundImageHookReducer, uploadLandingBackgroundImageHookInitialState);
  const basePath = getBasePath();

  const setLandingBackgroundImage = ({ userId, image }) => {
    const token = getAuthToken();
    let formData = new FormData();
    formData.append("image", image);
    axios({
      url: `${basePath}/user/${userId}/landing-background`,
      method: "POST",
      data: formData,
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((data) => {
        const backgroundImageData = data?.data?.data;
        dispatch({
          type: "success",
          payload: backgroundImageData,
        });
      })
      .catch((err) => {
        dispatch({ type: "error", payload: err?.response?.data?.error });
      });
  };

  const uploadLandingBackgroundImage = (payload) => {
    dispatch({ type: "fetching" });
    setLandingBackgroundImage(payload);
  };

  return [backgroundImage, uploadLandingBackgroundImage];
};

export default useUploadLandingBackgroundImage;
